module.exports = __webpack_public_path__ + "img/ring_y_c_1_null@2x.98a9cfac.png";